/* Galería de producto: fundido entre fotos, zoom al pasar el cursor, lightbox con flechas, swipe y pinch. */
(function () {
  var g = document.getElementById('kx-gal-img'), main = document.getElementById('kx-gal-main');
  if (!g || !main) return;
  var thumbs = [].slice.call(document.querySelectorAll('.kx-gal__thumbs button'));
  var srcs = thumbs.length ? thumbs.map(function (b) { return b.dataset.src; }) : [g.currentSrc || g.src];
  var idx = 0, lb = document.getElementById('kx-lb'), lbImg = document.getElementById('kx-lb-img');

  function go(i) {
    idx = (i + srcs.length) % srcs.length;
    thumbs.forEach(function (b, j) { if (j === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    var n = new Image();
    g.classList.add('is-fading');
    n.onload = function () { g.src = srcs[idx]; g.removeAttribute('srcset'); requestAnimationFrame(function () { g.classList.remove('is-fading'); }); };
    n.src = srcs[idx];
    if (lb && lb.open) show();
  }
  thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });

  if (matchMedia('(hover: hover)').matches) {
    main.addEventListener('mousemove', function (e) { var r = main.getBoundingClientRect(); g.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
    main.addEventListener('mouseenter', function () { main.classList.add('is-zoom'); });
    main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
  }

  if (!lb) return;
  var scale = 1, tx = 0, ty = 0, ptrs = {}, startDist = 0, startScale = 1, lastTap = 0, swipeX = null;
  function apply() { lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }
  function show() {
    lbImg.src = srcs[idx]; reset();
    lb.querySelectorAll('.kx-lb__dots button').forEach(function (d, j) { d.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
    lb.querySelector('.kx-lb__n').textContent = (idx + 1) + ' / ' + srcs.length;
  }
  main.addEventListener('click', function () { show(); lb.showModal(); });
  lb.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target === lb) { lb.close(); return; }
    if (e.target.closest('[data-prev]')) go(idx - 1);
    if (e.target.closest('[data-next]')) go(idx + 1);
    var d = e.target.closest('.kx-lb__dots button'); if (d) go(+d.dataset.i);
  });
  lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(idx - 1); if (e.key === 'ArrowRight') go(idx + 1); });

  var stage = lb.querySelector('.kx-lb__stage');
  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  stage.addEventListener('pointerdown', function (e) {
    ptrs[e.pointerId] = { x: e.clientX, y: e.clientY, sx: e.clientX, sy: e.clientY };
    stage.setPointerCapture(e.pointerId);
    var k = Object.keys(ptrs);
    if (k.length === 2) { startDist = dist(ptrs[k[0]], ptrs[k[1]]); startScale = scale; }
    else if (k.length === 1) swipeX = e.clientX;
  });
  stage.addEventListener('pointermove', function (e) {
    var p = ptrs[e.pointerId]; if (!p) return;
    var k = Object.keys(ptrs);
    if (k.length === 2) {
      var a = ptrs[k[0]], b = ptrs[k[1]]; if (e.pointerId === +k[0]) { a.x = e.clientX; a.y = e.clientY; } else { b.x = e.clientX; b.y = e.clientY; }
      scale = Math.min(4, Math.max(1, startScale * dist(a, b) / startDist)); apply();
    } else if (scale > 1) { tx += e.clientX - p.x; ty += e.clientY - p.y; p.x = e.clientX; p.y = e.clientY; apply(); }
  });
  function up(e) {
    var p = ptrs[e.pointerId]; delete ptrs[e.pointerId];
    if (!p) return;
    if (scale === 1 && swipeX !== null && Object.keys(ptrs).length === 0) {
      var dx = e.clientX - swipeX;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 6) { var now = Date.now(); if (now - lastTap < 300) { scale = 2.5; var r = stage.getBoundingClientRect(); tx = (r.width / 2 - (e.clientX - r.left)) * 1.5; ty = (r.height / 2 - (e.clientY - r.top)) * 1.5; apply(); } lastTap = now; }
    } else if (scale > 1 && Object.keys(ptrs).length === 0 && e.type === 'pointerup' && Math.abs(e.clientX - p.sx) < 6 && Math.abs(e.clientY - p.sy) < 6) {
      var t = Date.now(); if (t - lastTap < 300) reset(); lastTap = t;
    }
    swipeX = null;
  }
  stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
})();
